import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';

export const DebugPage: React.FC = () => {
    const { user } = useAuth();
    const [debugInfo, setDebugInfo] = useState<any>({});

    useEffect(() => {
        const checkDebugInfo = async () => {
            const info: any = {
                user: user,
                accessToken: localStorage.getItem('accessToken'),
                authToken: localStorage.getItem('authToken'),
                refreshToken: localStorage.getItem('refreshToken'),
            };

            try {
                // Test API calls
                const companyResponse = await api.getMyCompany();
                info.companyResponse = companyResponse;
            } catch (error: any) {
                info.companyError = error.message;
            }

            try {
                const bankingResponse = await api.getBankingDetails();
                info.bankingResponse = bankingResponse;
            } catch (error: any) {
                info.bankingError = error.message;
            }

            try {
                const employeesResponse = await api.getEmployees();
                info.employeesResponse = employeesResponse;
            } catch (error: any) {
                info.employeesError = error.message;
            }

            setDebugInfo(info);
        };

        checkDebugInfo();
    }, [user]);

    return (
        <div className="p-6">
            <h1 className="text-2xl font-bold mb-4">Debug Information</h1>
            <pre className="bg-gray-100 p-4 rounded-lg overflow-auto">
                {JSON.stringify(debugInfo, null, 2)}
            </pre>
        </div>
    );
};
